import API from "../API";
import APIFileUpload from "../APIFileUpload";

export const GetRatingandreviwsApi = async (payload) => {
  try {
    const response = await API.get(
      `/ecommerce/ratingandreview/${payload || ""}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetTenantRatingandreviwsApi = async () => {
  try {
    const response = await API.get(`/ecommerce/ratingandreview/tenant`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const PostRatingAndReviewApi = async (payload) => {
  try {
    const response = await API.post(`/ecommerce/ratingandreview`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const UpdateRatingAndReviewApi = async (payload) => {
  try {
    const response = await API.put(`/ecommerce/ratingandreview`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const DeleteRatingAndReviewApi = async (payload) => {
  try {
    const response = await API.post(`/ecommerce/ratingandreview`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

// export const RatingandreviewUploadFileApi = async (payload) => {
//     try {
//         console.log('files: ', payload)
//         const formData = new FormData();

//         payload.files.forEach((file) => {
//             formData.append("files", file); // important
//         });

//         const response = await APIFileUpload.post(`/ratingandreview/upload/file`, formData);
//         return response;
//     } catch (error) {
//         throw error;
//     }
// };

export const RatingandreviewUploadFileApi = async (payload) => {
  try {
    console.log("files: ", payload);
    const formData = new FormData();
    const rawFiles = payload?.files ?? payload;
    const files = Array.from(rawFiles || []).flat();

    if (!files.length) {
      throw new Error("No files provided for upload.");
    }

    const isFile = (value) =>
      (typeof File !== "undefined" && value instanceof File) ||
      (typeof Blob !== "undefined" && value instanceof Blob);

    files.forEach((file) => {
      if (isFile(file)) {
        formData.append("files", file);
      }
    });

    if (!formData.getAll("files").length) {
      throw new Error("Invalid file payload. Expected File/Blob objects.");
    }

    const response = await APIFileUpload.post(
      `/ecommerce/ratingandreview/upload/file`,
      formData,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const DeleteRatingandreviewUploadFileApi = async (payload) => {
  try {
    const response = await API.delete(
      `/ecommerce/ratingandreview/upload/file?key=${payload?.key || ""}`,
      payload,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetReviewVideoApi = async (payload) => {
  try {
    const response = await API.get(
      `/ecommerce/ratingandreview/videos/${payload?.productId}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};
